import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuthorizationViewModel } from '@viewModels/AuthorizationViewModel/AuthorizationViewModel';
import { ROUTES } from '@configs/AppRoutes';

export const useRouteTracker = () => {
    const location = useLocation();
    const { bearerToken, setLastAuthorizedPath } = useAuthorizationViewModel();

    useEffect(() => {
        if (!bearerToken) return;

        const full = '#' + location.pathname + location.search + location.hash;

        setLastAuthorizedPath(full ?? ROUTES.BOM);
    }, [bearerToken, location]);
};
